/* eslint-disable no-shadow */

export enum API_BASE_ROUTES {
	ozoner = '/v1/ozoner',
	loan = '/v1/loan',
	financialForm = '/v1/financial-form',
	leads = '/v1/leads',
}
